import { render, staticRenderFns } from "./french_daily_oneList.vue?vue&type=template&id=30b04875&scoped=true"
import script from "./french_daily_oneList.vue?vue&type=script&lang=js"
export * from "./french_daily_oneList.vue?vue&type=script&lang=js"
import style0 from "./french_daily_oneList.vue?vue&type=style&index=0&id=30b04875&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b04875",
  null
  
)

export default component.exports